<script>
import Switches from "vue-switches"

export default {
  props: { currentEmpresa: { type: Object } },
  components: {
    Switches,
  },
  data() {
    return {
      convenio: {
        id: null,
        name: null,
        is_private: null,
        empresa_id: null
      },
      loader: {
        get: false,
      },
    }
  },
  mounted() {
    this.$emit("newTitle", "Incluir Convênio")
    this.convenio.empresa_id = this.currentEmpresa.id
  },
  methods: {
    setPost() {
      this.$emit("doPost", this.convenio)
    },
  },
}
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        
        <div class="col-md-9">
          <label for="name">* Nome do Convênio</label>
          <input id="name" v-model="convenio.name" type="text" class="form-control" />
        </div>
        <div class="col-md-3">
          <h5 class="mt-4 font-size-14 mb-4">* É Particular?</h5>
          <switches v-model="convenio.is_private" color="success" class="ml-1"></switches>
        </div>
      </div>
      
    </div>
    <div class="card-body">
      <div class="col-md-12 mt-10">
        <button v-if="!loader.get" class="btn btn-success" @click.prevent="setPost()">
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>